(function ($) {
  $(document).ready(function () {

    $('#res__date').pickadate({
      container: '.res__date-container',
      firstDay: 1,
      format: 'dd/mm/yyyy',
      formatSubmit: 'yyyy-mm-dd',
      hiddenName: true,
      min: new Date()
    });

    $('.res-flyout__overlay').on('click', function () {
      $('.res-flyout__slide').toggleClass('show');
      $('.res-flyout__overlay').toggleClass('show');
      $('body').toggleClass('disable-scroll');
    });

    $('input.res__time, select#res__time').change(function () {
        $('.hidden-content', $(this).closest('form')).addClass('show');
    });


    $('form').submit(function () {
      return undefined === $(this).attr('data-submit');
    });

    $('.res-flyout form').submit(function () {
      $(this).attr('data-submit', 1);

      return true;
    });

  });
})(jQuery); // Fully reference jQuery after this point.